module.exports = __webpack_public_path__ + "static/media/fourWarriors-0.f9120fd1.png";